/* eslint-disable no-unused-vars */
/* eslint-disable consistent-return */
/* eslint-disable no-use-before-define */
/* eslint-disable import/no-named-as-default-member */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { format, fromUnixTime, getUnixTime } from "date-fns";
import { connect, useDispatch } from "react-redux";
import authActions from "../../redux/features/auth/actions";
import { buildErrorMessage } from "../../apis/calls";
import { usePopupManager } from "../PopupManager/PopupManager";
import StorageService from "../../utils/storageService";

const initializeScript = (src) =>
  new Promise((resolve, reject) => {
    if (!window.epAppData) {
      reject(new Error("epAppData is not available"));
      return;
    }
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => resolve();
    script.onerror = (e) => reject(e);
    document.body.appendChild(script);
  });

const AuthorizationHandler = ({
  authToken,
  children,
  keycloak,
  loadAuthData,
  setAuthToken,
  recentAPICalls,
  refresh,
}) => {
  const dispatch = useDispatch();
  // const SSO_SESSION_CHECK_INTERVAL_MS = 60000;
  const { showError } = usePopupManager();
  const [isProcessingCode, setIsProcessingCode] = useState(false);

  const getISTTime = (unixTimestamp) =>
    format(fromUnixTime(unixTimestamp), "hh:mma");

  // Extract authorization code from URL hash using window.location
  // Extract authorization code from URL query parameters (not hash)
  const extractAuthCodeFromURL = () => {
    // Check both query params and hash for compatibility
    let params;

    // First try query parameters (what you're currently getting)
    if (window.location.search) {
      params = new URLSearchParams(window.location.search);
    }
    // Fallback to hash if no query params
    else if (window.location.hash) {
      const hash = window.location.hash.substring(1);
      params = new URLSearchParams(hash);
    } else {
      return { code: null, state: null, sessionState: null };
    }

    const code = params.get("code");

    return { code };
  };

  // Send code to backend for token exchange
  const exchangeCodeOnBackend = async (code) => {
    try {
      const redirectUri = `${window.location.origin}${window.location.pathname}`;
      const clientId = StorageService.getItem("clientId");

      const response = await fetch(
        `${window.epAppData.API_BASE_URL}/user/auth/callback/`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            code,
            redirect_uri: redirectUri,
            client_type:clientId
          }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        console.error("Backend code exchange failed:", errorData);
        throw new Error(errorData.message || "Backend code exchange failed");
      }

      const data = await response.json();
      StorageService.setItem("accessToken",data.tokens.access_token)
      StorageService.setItem("refreshToken",data.tokens.refresh_token)
      return data.tokens.access_token;
    } catch (error) {
      console.log("Code exchange error:", error);
      showError("Authentication failed. Please try again.");
      throw error;
    }
  };

  // const checkSSOSessionStatePeriodically = () => {
  //   if (localStorage.getItem("stopApiCalls") === "false" && keycloak) {
  //     keycloak
  //       .loadUserInfo()
  //       .then(() =>
  //         setTimeout(
  //           checkSSOSessionStatePeriodically,
  //           SSO_SESSION_CHECK_INTERVAL_MS
  //         )
  //       )
  //       .catch((error) => {
  //         const { exp, iat, auth_time: authTime } = keycloak.tokenParsed;
  //         console.error(
  //           `failed user check, error:${buildErrorMessage(
  //             error
  //           )}; exp:${getISTTime(exp)} iat:${getISTTime(iat)} ` +
  //             `auth:${getISTTime(authTime)}`
  //         );
          // refreshTokenAndContinueUserSessionCheckElseLogout();
  //       });
  //   }
  // };

  // const refreshTokenAndContinueUserSessionCheckElseLogout = () => {
  //   refreshToken()
  //     .then(() => {
  //       checkSSOSessionStatePeriodically();
  //     })
  //     .catch((error) => {
  //       console.error({ error });
  //       console.error(
  //         `Failed to refresh the token, or the session has expired.Err:${buildErrorMessage(
  //           error
  //         )} Logging user out...`
  //       );
  //     });
  // };

  // const refreshToken = () =>
  //   keycloak.updateToken(-1).then((refreshed) => {
  //     console.log("refreshedToken: refreshed:", refreshed);
  //     setAuthToken(keycloak.token);
  //   });

  // const setRefreshBeforeTimeout = () => {
  //   const expirtytimeInUnixSeconds = keycloak.tokenParsed.exp;
  //   const { sub: userID, exp, iat, auth_time: authTime } = keycloak.tokenParsed;
  //   const currentTimeInUnixSeconds = getUnixTime(new Date());
  //   const sixtySeconds = 60;
  //   const remainingTimeToRefreshInMS =
  //     (expirtytimeInUnixSeconds - currentTimeInUnixSeconds - sixtySeconds) *
  //     1000;

  //   dispatch(authActions.setRemainingTime(remainingTimeToRefreshInMS));

  //   console.info(
  //     `setting token refresh - userID: ${userID} ` +
  //       `exp:${getISTTime(exp)} iat:${getISTTime(iat)} ` +
  //       `auth:${getISTTime(authTime)}`
  //   );
  //   return setTimeout(() => {
  //     console.info(`userID: ${userID}: calling refresh before token expiry`);
  //   }, remainingTimeToRefreshInMS);
  // };

  // const generateRandomString = (length) => {
  //   const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  //   let result = '';
  //   const randomValues = new Uint8Array(length);
  //   crypto.getRandomValues(randomValues);
  //   randomValues.forEach((value) => {
  //     result += charset[value % charset.length];
  //   });
  //   return result;
  // };

  const initializeKeycloakForLogin = async () => {
    if (!window.epAppData) {
      setTimeout(initializeKeycloakForLogin, 100);
      return;
    }

    try {
      await initializeScript(
        `${window.epAppData.AUTH_ENDPOINT}/js/keycloak.js`
      );
      const response = await fetch("/keycloak.json");
      const config = await response.json();

      const clientId = StorageService.getItem("clientId");
      let kcConfig = { ...config };
      if (clientId) {
        kcConfig = { ...kcConfig, resource: clientId, clientId };
      }

      // Manually construct login URL with PKCE
      const redirectUri = `${window.location.origin}${window.location.pathname}`;
      // const state = generateRandomString(32);

      const loginUrl =
        `${window.epAppData.AUTH_ENDPOINT}/realms/${kcConfig.realm}/protocol/openid-connect/auth?` +
        `client_id=${kcConfig.resource}&` +
        `redirect_uri=${encodeURIComponent(redirectUri)}&` +
        `response_type=code&` +
        `scope=openid`;

      window.location.href = loginUrl;
    } catch (err) {
      console.error("Failed to initialize Keycloak for login:", err);
      showError("Failed to initialize authentication");
    }
  };

  const fetchData=async()=>{
    try{
      const response = await fetch(`${window.epAppData.API_BASE_URL}/health/live/`);
      
      console.log("health check response:",response)
    }catch(error){
      console.error("failed to load resources",error)
    }
  }
  useEffect(() => {
    if (isProcessingCode) return;

    const { code } = extractAuthCodeFromURL();

    if (code && !authToken) {
      setIsProcessingCode(true);

      fetchData();
      exchangeCodeOnBackend(code)
        .then((token) => {
          // Clean URL using window.history
          window.history.replaceState(
            {},
            document.title,
            window.location.pathname
          );

          // Load auth data with token from backend
          loadAuthData(token, true, showError);
          setIsProcessingCode(false);
        })
        .catch((error) => {
          console.error("Failed to exchange code:", buildErrorMessage(error));
          setIsProcessingCode(false);
          initializeKeycloakForLogin();
        
          // Redirect back to login
        });
    } else if (!code && !authToken && !isProcessingCode) {
      // No code and not authenticated - redirect to login
      initializeKeycloakForLogin();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect(() => {
  //   if (!authToken || !keycloak) return;
  //   const timeout = setRefreshBeforeTimeout();
  //   return () => clearTimeout(timeout);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [authToken]);

  // useEffect(() => {
  //   if (recentAPICalls.length > 0 && keycloak) {
  //     refreshToken().catch((err) =>
  //       console.error(`failed to refresh token ${buildErrorMessage(err)}`)
  //     );
  //   }
  // }, [recentAPICalls]);

  // useEffect(() => {
  //   if (refresh && keycloak) {
  //     refreshToken().catch((err) =>
  //       console.error(`failed to refresh token ${buildErrorMessage(err)}`)
  //     );
  //     dispatch(authActions.setRefresh(false));
  //   }
  // }, [refresh]);

  return <>{children}</>;
};

AuthorizationHandler.defaultProps = {
  children: null,
  keycloak: null,
};

AuthorizationHandler.propTypes = {
  children: PropTypes.node,
  loadAuthData: PropTypes.func.isRequired,
  keycloak: PropTypes.object,
  setAuthToken: PropTypes.func.isRequired,
  authToken: PropTypes.string,
  recentAPICalls: PropTypes.array,
  refresh: PropTypes.bool,
};

export default connect(
  (state) => ({
    keycloak: state.auth.keycloak,
    authToken: state.auth.authToken,
    recentAPICalls: state.auth.recentAPICalls,
    refresh: state.auth.refresh,
  }),
  {
    setKeycloakInstance: authActions.setKeycloakInstance,
    loadAuthData: authActions.loadAuthData,
    logoutUser: authActions.logoutUser,
    setAuthToken: authActions.setAuthToken,
    setRemainingTime: authActions.setRemainingTime,
    setRefresh: authActions.setRefresh,
  }
)(AuthorizationHandler);
